var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoProyecto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_687",
    "data-name": "Group 687",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.838,
    height: 78.647,
    viewBox: "0 0 216.838 78.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #24303c;\r\n      }\r\n\r\n      .cls-3 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    className: "cls-1",
    width: 216.838,
    height: 78.647
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    className: "cls-2",
    width: 73.516,
    height: 51.515,
    transform: "translate(143.322 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2770",
    "data-name": "Path 2770",
    className: "cls-2",
    d: "M0,9H19.545C32.77,9,39.971,17.006,39.971,26.925a16.816,16.816,0,0,1-10.948,15.8L40.338,56.609h-6.98l-9.7-12.271a28.867,28.867,0,0,1-4.629.367H5.878v11.9H0ZM19.985,39.636c8.082,0,13.814-5.731,13.814-12.711,0-7.127-5.658-12.858-13.74-12.858H5.878v25.57Z",
    transform: "translate(0 -7.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2771",
    "data-name": "Path 2771",
    className: "cls-2",
    d: "M217.4,37.653V9h5.878V37.432c0,8.817,4.849,14.475,13.887,14.475,8.964,0,13.887-5.658,13.887-14.475V9h5.878V37.653c0,11.9-7.421,19.692-19.765,19.692-12.417,0-19.765-7.788-19.765-19.692",
    transform: "translate(-169.272 -7.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2772",
    "data-name": "Path 2772",
    className: "cls-2",
    d: "M438.55,8.332h5.29l22.337,47.76h-5.952l-4.408-9.258h-29.17l-4.409,9.258h-6.025Zm15.136,33.726-8.744-18.516c-1.616-3.453-3.453-8.009-3.747-8.6-.294.588-2.057,5.07-3.747,8.6L428.7,42.058Z",
    transform: "translate(-324.074 -6.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2773",
    "data-name": "Path 2773",
    className: "cls-4",
    d: "M679.88,16.491l-10.434,7.495L666.8,19.945,680.541,9h4.923V56.609H679.88Z",
    transform: "translate(-519.189 -7.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2774",
    "data-name": "Path 2774",
    className: "cls-4",
    d: "M845.235,22.356a19.34,19.34,0,0,1-4.482,12.05l-16.9,20.5-4.482-3.38,11.315-13.3a11.811,11.811,0,0,1-3.453.588,15.959,15.959,0,0,1-16.385-16.238c0-9.405,6.76-16.9,17.193-16.9,10.654,0,17.193,7.421,17.193,16.679M816.8,22.43a11.173,11.173,0,0,0,11.242,11.536A11.351,11.351,0,0,0,839.283,22.43c0-6.539-4.482-11.683-11.242-11.683-6.613,0-11.242,5.07-11.242,11.683",
    transform: "translate(-631.348 -4.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2775",
    "data-name": "Path 2775",
    className: "cls-2",
    d: "M143.624,296.116h.573l6.281,12.9h-.81l-1.363-2.785h-8.769l-1.363,2.785h-.829Zm4.365,9.421-3.357-6.834c-.514-1.047-.711-1.56-.711-1.56s-.217.513-.731,1.56l-3.338,6.834Z",
    transform: "translate(-106.939 -230.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2776",
    "data-name": "Path 2776",
    className: "cls-2",
    d: "M205.421,296.563h5.194c3.318,0,5.214,2.114,5.214,4.721,0,2.587-1.9,4.7-5.234,4.7h-4.385v3.377h-.79Zm5.352,8.71a4.006,4.006,0,1,0,.02-8h-4.582v8Z",
    transform: "translate(-159.946 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2777",
    "data-name": "Path 2777",
    className: "cls-2",
    d: "M257.029,296.116h.573l6.281,12.9h-.81l-1.363-2.785h-8.77l-1.363,2.785h-.829Zm4.365,9.421-3.358-6.834c-.513-1.047-.711-1.56-.711-1.56s-.217.513-.731,1.56l-3.338,6.834Z",
    transform: "translate(-195.239 -230.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2778",
    "data-name": "Path 2778",
    className: "cls-2",
    d: "M318.826,296.563h5.1c3.614,0,5.333,2.114,5.333,4.721a4.665,4.665,0,0,1-3.259,4.4l3.239,3.674h-.968l-3.041-3.5a8.765,8.765,0,0,1-1.363.119h-4.247v3.377h-.79Zm5.254,8.71c2.587,0,4.345-1.58,4.345-3.99,0-2.429-1.6-4.01-4.325-4.01h-4.484v8Z",
    transform: "translate(-248.246 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2779",
    "data-name": "Path 2779",
    className: "cls-2",
    d: "M374.631,297.274h-5.036v-.711h10.843v.711h-5.017v12.088h-.79Z",
    transform: "translate(-287.776 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2780",
    "data-name": "Path 2780",
    className: "cls-2",
    d: "M421.2,296.116h.573l6.281,12.9h-.81l-1.363-2.785h-8.769l-1.363,2.785h-.83Zm4.365,9.421-3.357-6.834c-.514-1.047-.711-1.56-.711-1.56s-.217.513-.731,1.56l-3.338,6.834Z",
    transform: "translate(-323.068 -230.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2781",
    "data-name": "Path 2781",
    className: "cls-2",
    d: "M483,296.563h.77l4.582,6.419c.435.593,1.165,1.659,1.165,1.659s.731-1.047,1.166-1.659l4.622-6.419h.731v12.8h-.79V297.827s-.3.494-.632.968l-5.1,7.09-5.1-7.11c-.316-.454-.632-.948-.632-.948v11.534H483Z",
    transform: "translate(-376.076 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2782",
    "data-name": "Path 2782",
    className: "cls-2",
    d: "M556.7,296.563h9.421v.711h-8.631v4.76h8.019v.711h-8.019v5.905h8.947v.711H556.7Z",
    transform: "translate(-433.46 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2783",
    "data-name": "Path 2783",
    className: "cls-2",
    d: "M611.839,296.563h.751l8.394,10.586c.336.435.691,1.027.691,1.027V296.563h.79v12.8h-.79l-8.354-10.507a7.76,7.76,0,0,1-.691-1.027v11.534h-.79Z",
    transform: "translate(-476.394 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2784",
    "data-name": "Path 2784",
    className: "cls-2",
    d: "M674.514,297.274h-5.036v-.711H680.32v.711H675.3v12.088h-.79Z",
    transform: "translate(-521.273 -230.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2785",
    "data-name": "Path 2785",
    className: "cls-2",
    d: "M721.495,302.268a6.6,6.6,0,1,1,6.6,6.6,6.521,6.521,0,0,1-6.6-6.6m12.364,0a5.768,5.768,0,1,0-5.767,5.846,5.742,5.742,0,0,0,5.767-5.846",
    transform: "translate(-561.775 -230.217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2786",
    "data-name": "Path 2786",
    className: "cls-2",
    d: "M789.127,306.693l.435-.553a5.66,5.66,0,0,0,4.444,1.975c1.975,0,4.128-.81,4.128-2.864,0-1.778-2.074-2.291-4.069-2.8-2.252-.573-4.365-1.323-4.365-3.476,0-2.192,2.133-3.3,4.306-3.3a5.741,5.741,0,0,1,4.068,1.461l-.395.593a5.236,5.236,0,0,0-3.674-1.3c-1.7,0-3.5.83-3.5,2.548,0,1.659,1.817,2.173,3.733,2.686,2.311.613,4.721,1.323,4.721,3.595,0,2.587-2.588,3.614-4.957,3.614a6.142,6.142,0,0,1-4.878-2.173",
    transform: "translate(-614.435 -230.218)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoProyecto);
export default __webpack_public_path__ + "static/media/logo-proyecto.6ffac3edeb0aef4e6b53645a256422e6.svg";
export { ForwardRef as ReactComponent };